import React from "react";
import LandItemSkeleton from "../../../../components/landItemSkeleton";
import Logo from "../../../../assets/images/logo.svg";

export const LandsSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-white pt-[20px]">
      <div className="py-24 px-6 md:px-12 lg:px-16 max-w-screen-2xl mx-auto">
        <div className="mb-12">
          <div className="w-32 h-10 bg-gray-200 animate-pulse rounded mb-6"></div>
          <div className="w-64 h-12 bg-gray-200 animate-pulse rounded"></div>
        </div>
        <div className="border-t border-b border-gray-200 py-6">
          <div className="relative mt-2 w-full md:w-[40%] md:ml-[30%]">
            <img
              className="absolute top-[2%] left-[2%] w-[26%] invert brightness-0 opacity-50"
              src={Logo}
              alt="logo"
            />
            <div className="w-full aspect-video bg-gray-200 h-[60vh] md:h-[550px] animate-pulse rounded-md"></div>
          </div>
          <div className="border-solid border-b border-gray-200 my-[3%]"></div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-8 gap-y-12 mt-8">
          {Array(6)
            .fill(0)
            .map((_, index) => (
              <div key={`skeleton-${index}`}>
                <LandItemSkeleton />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
